import React from "react";
import { getCmsData } from "../../../functions";
import TopTopicsCard from "./top-topics-card/TopTopicsCard";

const TopTopics = () => {
  const cmsData = getCmsData("topTopicsDataCMS");
  if (!cmsData) return null;

  const { heading, cards } = cmsData;

  return (
    <section id="top-topics">
      <div className="container-fluid">
        <h2>{heading}</h2>
        <div className="row">
          <div className="col-sm-12 col-md-6 col-lg-3 top-topics-card-container d-flex align-items-stretch">
            <TopTopicsCard topicsData={cards[0]} />
          </div>
          <div className="col-sm-12 col-md-6 col-lg-3 top-topics-card-container d-flex align-items-stretch">
            <TopTopicsCard topicsData={cards[1]} />
          </div>
          <div className="col-sm-12 col-md-6 col-lg-3 top-topics-card-container d-flex align-items-stretch">
            <TopTopicsCard topicsData={cards[2]} />
          </div>
          <div className="col-sm-12 col-md-6 col-lg-3 top-topics-card-container d-flex align-items-stretch">
            <TopTopicsCard topicsData={cards[3]} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default TopTopics;
